import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "stop-circle",
  "use": "stop-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"stop-circle\">\n<path d=\"M12,23C5.9,23,1,18.1,1,12S5.9,1,12,1s11,4.9,11,11S18.1,23,12,23z M12,3c-5,0-9,4-9,9c0,5,4,9,9,9c5,0,9-4,9-9\n\tC21,7,17,3,12,3z\" />\n<path d=\"M15,16H9c-0.6,0-1-0.4-1-1V9c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v6C16,15.6,15.6,16,15,16z M10,14h4v-4h-4V14z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol